import IProgram from "../../../models/Program";
import moment from "moment";
// import Link from "next/link";
import { Link } from "react-router-dom";

interface IProgramListProps {
  data: IProgram[];
  limit?: number;
}

const LatestProgrammes = ({ data, limit = 3 }: IProgramListProps) => {
  return (
    <div className="flex flex-col gap-3">

      {/* Header */}
      <div className="grid grid-cols-4 text-xs text-[#545455] font-bold px-2">
        <span>Programme name</span>
        <span className="text-center">Sessions</span>
        <span className="text-center">Date</span>
        <span></span>
      </div>

      {/* Rows */}
      {data.slice(0, limit).map((el: any) => (
        <div
          key={el.id}
          className="grid grid-cols-4 items-center bg-white rounded-xl px-4 py-3 shadow-[0_2px_8px_rgba(0,0,0,0.06)]"
        >
          <div className="text-sm text-[#545455] font-normal truncate">
            {el.name}
          </div>

          <div className="text-center text-sm text-[#545455] font-normal">
            {el.sessions?.length ?? "—"}
          </div>

          <div className="text-center text-sm text-[#545455] font-normal">
            {moment(el.startDate).format("DD MMM YYYY")} -{" "}
            {moment(el.endDate).format("DD MMM YYYY")}
          </div>

          <div className="text-right">
            <Link
              to={`/program-detail/${el.programBatchId}`}
              className="text-[#5F488A] text-[11px] font-semibold"
            >
              VIEW
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LatestProgrammes;